export default __webpack_public_path__ + "static/media/icon-satisfied-active.e7c9fe96.svg";